module.exports = __webpack_public_path__ + "static/media/social-media.8f4e1855.gif";